import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Permissions from '../Utilities/Permissions';
import  Actions from '../Actions';

class PrivateRoute extends Component{
    constructor(props){
        super(props);
        this.permissions = new Permissions(props.permissions);
    }
    authenticated = () => {
        const { token, user, permissions } = this.props;
        return (!token || !user || permissions === {}) ? false:true;
    }  
    render(){
        const { page = "" } = this.props;
        if(!this.authenticated()) this.props.logout();
        return this.authenticated() && (!page || page === "stats" || this.permissions.can("post",page))? <Route {...this.props} />:<Redirect to="/" />;
    }
}
const mapStateToProps = (state) => ({
    token: state.auth.token,
    user: state.auth.user,
    permissions: state.auth.permissions,
});

export default connect(mapStateToProps, Actions.auth)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/Components/PrivateRoute.js